import Styles from '../../../1.manual/3.school/2.edit/styles.module.css';
import React from 'react';
import { useState } from 'react';
import { getFirestore } from 'firebase/firestore';
import { writeJobPostingBothStores } from '../../jobPostingRef';
import DefaultCheckBox from '../../../../package/checkBox/index';
import ErrorMessage from '../../../../package/error/index';
import { targetData, ValidationError } from '../../../../../type';
import DefaultDesc from 'src/salon/package/desc';

type EmploymentProps = {
  companyId: string;
  year: string;
  setChangeData: React.Dispatch<React.SetStateAction<boolean>>;
  target: targetData;
  setTarget: React.Dispatch<React.SetStateAction<targetData>>;
};

const SchoolTarget: React.FC<EmploymentProps> = ({ companyId, year, setChangeData, target, setTarget }) => {

  const [ errorMessage, setErrorMessage ] = useState<ValidationError>(null);
  const [ banner, setBanner ] = useState<boolean>(false);

  function validateData(data: targetData): ValidationError {
    if (!data.target) {
      return { message: '募集区分を入力してください。', fieldId: 'target' };
    }
    return null;
  }

  function scrollToError(fieldId: string) {
    const el = document.getElementById(fieldId);
    if (!el) return;

    el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    el.focus?.();
  }

  function check() {
    setErrorMessage(null);
    window.scrollTo(0, 0);

    const error = validateData(target);

    if (error) {
      setErrorMessage(error);
      scrollToError(error.fieldId);
      return;
    }

    save(true);
  }

  const db = getFirestore();

  const [ uploading, setUploading ] = useState(false);

  async function save(isCompleted: boolean) {
    const payload = {
      ...target,
      isCompleted,
      time: new Date(),
    };

    try {
      setUploading(true);

      await writeJobPostingBothStores(db, companyId, year, {
        target: payload,
      });

      setChangeData(false);

    } catch (error) {
      setUploading(false);
      console.error('Failed to update document:', error);
    } finally {
      setUploading(false);
      setBanner(true);
      setTimeout(() => { setBanner(false); }, 1500);
    }
  }

  return (
    <>
    {errorMessage && <ErrorMessage message={errorMessage.message} />}
    {banner && <div className={Styles.banner}>保存しました。</div>}

    {uploading && (
      <div className={Styles.lockOverlay}>
        <div className={Styles.spinner} />
        <p>アップロード中...</p>
      </div>
    )}

    <div className={Styles.title_edit}>
      <h4>募集区分</h4>
      <div className={Styles.title_edit_btn}>
        <button className={Styles.save_box_now} onClick={() => save(false)}>一時保存</button>
        <button className={Styles.save_box_save} onClick={() => check()}>保存</button>
      </div>
    </div>

    <div className={Styles.test_box}>

      <DefaultCheckBox
        error={false}
        title={'募集区分'} list={[ '専門(20歳卒)', '高専(18歳卒)', '高専(17歳卒)' ]}
        value={target.target}
        setValue={(val: string[]) => {
          const fixed = val.includes('専門(20歳卒)') ? val : ['専門(20歳卒)', ...val];
          setTarget((prev) => ({ ...prev, target: fixed }));
          setChangeData(true);
        }} />
      <DefaultDesc text={"※専門(20歳卒)の未選択は出来ません。"} />

    </div>

    </>
  );
}

export default SchoolTarget;
